export const LotusMark = ({ className = "h-8 w-8", id = "lotus" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#D48A72" />
        <stop offset="1" stopColor="#8E3F30" />
      </linearGradient>
    </defs>
    <g fill="none" stroke={`url(#${id})`} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M32 10c7 8 8 22 0 32c-8-10-7-24 0-32z" />
      <path d="M29 42c-9-1-16-8-18-18c8 1 15 7 18 18z" />
      <path d="M35 42c9-1 16-8 18-18c-8 1-15 7-18 18z" />
      <path d="M16 50c10 4 22 4 32 0" />
    </g>
  </svg>
);

export const Logo = ({ light = false, id }) => (
  <span className="flex items-center gap-2.5">
    <LotusMark className="h-9 w-9" id={id} />
    <span className="flex flex-col leading-none">
      <span className={`font-display-serif text-[1.45rem] tracking-[0.12em] ${light ? "text-[#FAF5EE]" : "text-[#2D1C18]"}`}>
        AISLA
      </span>
      <span className={`text-[0.6rem] font-semibold tracking-[0.55em] ${light ? "text-[#E9C9BC]" : "text-[#6B5650]"}`}>
        STUDIO
      </span>
    </span>
  </span>
);

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.94.95-3.48-.22-.36a9.42 9.42 0 0 1-1.44-5.02c0-5.2 4.24-9.44 9.44-9.44 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.68c0 5.2-4.24 9.43-9.44 9.43zm8.03-17.46A11.27 11.27 0 0 0 12.04.72C5.79.72.7 5.8.7 12.06c0 2 .52 3.95 1.52 5.67L.6 23.6l6.01-1.58a11.3 11.3 0 0 0 5.42 1.38h.01c6.25 0 11.34-5.09 11.34-11.34 0-3.03-1.18-5.88-3.31-8.02z" />
  </svg>
);
